/* eslint-disable react/prop-types */
import Chip from "@mui/material/Chip";
import Icon from "@mui/material/Icon";

export function StatutChip({ statut }) {
  return (
    <Chip
      label={statut}
      size="small"
      sx={{
        bgcolor: statut === "ACTIF" ? "#e8f5e9" : "#f5f5f5",
        color: statut === "ACTIF" ? "#2e7d32" : "#757575",
        fontWeight: 600,
        fontSize: "0.7rem",
      }}
    />
  );
}

export function AnalyseChip({ analysee }) {
  return (
    <Chip
      icon={
        <Icon sx={{ fontSize: "0.9rem !important" }}>
          {analysee ? "check_circle" : "radio_button_unchecked"}
        </Icon>
      }
      label={analysee ? "Analysée" : "Non analysée"}
      size="small"
      sx={{
        bgcolor: analysee ? "#e3f2fd" : "#fafafa",
        color: analysee ? "#1565c0" : "#9e9e9e",
        fontWeight: 600,
        fontSize: "0.7rem",
      }}
    />
  );
}

export function EcartBadge({ ligne }) {
  if (!ligne.procedure_id) {
    return (
      <Chip
        icon={<Icon sx={{ fontSize: "0.85rem !important" }}>close</Icon>}
        label="Aucune procédure"
        size="small"
        sx={{ bgcolor: "#ffebee", color: "#c62828", fontWeight: 600, fontSize: "0.7rem" }}
      />
    );
  }
  if (ligne.ecart_procedure) {
    return (
      <Chip
        icon={<Icon sx={{ fontSize: "0.85rem !important" }}>warning</Icon>}
        label="Écart"
        size="small"
        sx={{ bgcolor: "#fff8e1", color: "#e65100", fontWeight: 600, fontSize: "0.7rem" }}
      />
    );
  }
  return (
    <Chip
      icon={<Icon sx={{ fontSize: "0.85rem !important" }}>check_circle</Icon>}
      label="Conforme"
      size="small"
      sx={{ bgcolor: "#e8f5e9", color: "#2e7d32", fontWeight: 600, fontSize: "0.7rem" }}
    />
  );
}
